<ng-container *ngIf="hasEditListPermission && listStatus">
  <span
    *ngIf="listStatus === listStatusConstants.archived"
    class="c-list-status__label c-list-status__label--archived label"
    i18n="@@listStatus-listStatus-archived"
    >Archived</span
  >
  <span
    *ngIf="listStatus === listStatusConstants.draft"
    class="c-list-status__label c-list-status__label--draft label"
    i18n="@@listStatus-listStatus-draft"
    >Draft List</span
  >
  <span
    *ngIf="listStatus === listStatusConstants.published"
    class="c-list-status__label c-list-status__label--published label"
    i18n="@@listStatus-listStatus-published"
    >Published</span
  >
  <span
    *ngIf="listStatus === listStatusConstants.publishedWithUnpublishedChanges"
    class="c-list-status__label c-list-status__label--published-with-unpublished-changes label"
    i18n="@@listStatus-listStatus-publishedWithUnpublishedChanges"
    >Unpublished Changes</span
  >
</ng-container>
